import { Outlet } from "react-router-dom";
import { Suspense } from "react";

import { ToastContainer } from "react-toastify";

import styles from "./LoginLayout.module.css";

export default function LoginLayout() {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                {/* A class rather than style={{...}}: style-src 'self' blocks inline
                    style attributes on this host. */}
                <main className={styles.main}>
                    <Outlet />
                </main>
            </Suspense>

            <ToastContainer theme="light" />
        </>
    );
}
